var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-users-block rounded shadow-sm mb-3" },
    [
      _c(
        "div",
        {
          class: {
            "row no-gutters py-2 px-3 text-white rounded-top bg-danger": true,
            "initial-user-list": _vm.userList.isInitialUserList
          }
        },
        [
          _c(
            "div",
            { staticClass: "col-6 d-inline-block my-auto widget-title" },
            [_vm._v("\n      " + _vm._s(_vm.widgetTitle) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-6 d-inline-block text-right smaller-font-content"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  on: {
                    click: function($event) {
                      return _vm.submitUserList(false)
                    }
                  }
                },
                [
                  _vm.userList.isInitialUserList
                    ? _c("span", [
                        _c("i", { staticClass: "fas fa-plus-circle" }),
                        _vm._v(" Add Users")
                      ])
                    : _c("span", [_vm._v("Save Updates")])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters px-3 my-3" }, [
        _c("div", { staticClass: "col-md-10" }, [
          !_vm.userList.isInitialUserList
            ? _c("p", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.widgetInfo.widgetDescription))
              ])
            : _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "Please review the list of users to make sure all information is correct. Click the “Add Users” button to add the users to the account. All carrier and state assignment can be updated from the user management screen."
                )
              ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters px-3 my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("b-table", {
              staticClass: "smaller-font-content",
              attrs: {
                small: "",
                hover: "",
                responsive: "",
                fields: _vm.getColumns(false),
                items: _vm.getRows(),
                id: "import-users-table"
              },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.importUsersColumns, function(
                    importUsersColumn,
                    i
                  ) {
                    return {
                      key: importUsersColumn.key,
                      fn: function(data) {
                        return [
                          _c("div", { key: i }, [
                            data.field.key === "discard"
                              ? _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: data.value,
                                        expression: "data.value"
                                      }
                                    ],
                                    ref: data.field.key + data.index,
                                    refInFor: true,
                                    staticClass: "form-control",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(data.value)
                                        ? _vm._i(data.value, null) > -1
                                        : data.value
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = data.value,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  data,
                                                  "value",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  data,
                                                  "value",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(data, "value", $$c)
                                          }
                                        },
                                        function($event) {
                                          return _vm.toggleDiscardRow(data)
                                        }
                                      ]
                                    }
                                  })
                                ])
                              : data.field.key === "role"
                              ? _c("div", [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: data.value,
                                          expression: "data.value"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{ required: true}"
                                        }
                                      ],
                                      ref: data.field.key + data.index,
                                      refInFor: true,
                                      staticClass:
                                        "form-control select-box-role",
                                      class: {
                                        error: _vm.errors.has(
                                          data.field.key + "_" + data.index
                                        )
                                      },
                                      attrs: {
                                        name: data.field.key + "_" + data.index
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              data,
                                              "value",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            return _vm.dataUpdate(data)
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("-Select One-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Agent" } },
                                        [_vm._v("Agent")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "AgencyAdmin" } },
                                        [_vm._v("Agency Admin")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "AgencyManager" } },
                                        [_vm._v("Agency Manager")]
                                      )
                                    ]
                                  )
                                ])
                              : data.field.key !== "errorMessage" &&
                                data.field.key !== "role"
                              ? _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.getValidationRule(data),
                                        expression: "getValidationRule(data)"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: data.value,
                                        expression: "data.value"
                                      }
                                    ],
                                    ref: data.field.key + data.index,
                                    refInFor: true,
                                    staticClass: "form-control",
                                    class: {
                                      error: _vm.errors.has(
                                        data.field.key + "_" + data.index
                                      )
                                    },
                                    attrs: {
                                      type: "text",
                                      name: data.field.key + "_" + data.index,
                                      maxlength:
                                        data.field.key === "middleInitial"
                                          ? 1
                                          : ""
                                    },
                                    domProps: { value: data.value },
                                    on: {
                                      change: function($event) {
                                        return _vm.dataUpdate(data)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          data,
                                          "value",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              : _c("span", [
                                  _c("label", [_vm._v(_vm._s(data.value))])
                                ])
                          ])
                        ]
                      }
                    }
                  })
                ],
                null,
                true
              )
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 text-right" }, [
      _c("p", { staticClass: "mb-0 smaller-font-content" }, [
        _c(
          "span",
          {
            staticClass: "font-weight-bold",
            staticStyle: { color: "#BB0000" }
          },
          [_vm._v("*")]
        ),
        _vm._v("Required")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b4bc9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4bc9e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/ImportusersBlock.vue
// module id = null
// module chunks = 